"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Sidebar = _interopRequireDefault(require("react-rainbow-components/components/Sidebar"));

var _reactRouterDom = require("react-router-dom");

var SideBarNavigation = function SideBarNavigation(props) {
  var className = props.className,
      style = props.style,
      children = props.children;
  var location = (0, _reactRouterDom.useLocation)();

  var routes = _react["default"].Children.map(children, function (element) {
    return {
      path: element.props.path,
      name: element.props.name,
      exact: element.props.exact
    };
  });

  var currentRoute = routes.find(function (route) {
    var match = (0, _reactRouterDom.matchPath)(location.pathname, route);
    return match;
  });
  var selectedItem = currentRoute ? currentRoute.name : '';
  return /*#__PURE__*/_react["default"].createElement(_Sidebar["default"], {
    className: className,
    style: style,
    selectedItem: selectedItem
  }, children);
};

SideBarNavigation.propTypes = {
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,

  /**
  * @ignore
  */
  children: _propTypes["default"].arrayOf(_propTypes["default"].node)
};
SideBarNavigation.defaultProps = {
  className: undefined,
  style: undefined,
  children: undefined
};
var _default = SideBarNavigation;
exports["default"] = _default;